export class PaintRequest {
    CarBrand: string;
    CarPaintColor: string;
    InternalItemNumbers: number[];
    Remarks: string;
}
